import { useProfileInfo } from "@/react/hooks/profile/useProfileInfo";
import { usePunditUserContext } from "@circle-react/contexts";
import type { FieldTypes } from "../../constants";
import { DISPLAY_OPTION_FIELD_INPUTS, FIELD_TYPES } from "../../constants";

export const useCurrentUserLocationInfo = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const {
    getProfileInfoQuery: { data },
  } = useProfileInfo({
    publicId: currentCommunityMember?.public_uid ?? "",
    params: {
      page_name: DISPLAY_OPTION_FIELD_INPUTS.EDIT_PROFILE,
    },
  });

  const platformLocationField = data?.profile_fields.visible.find(field =>
    isPlatformLocationField({
      field_type: field.field_type,
      platform_field: field.platform_field,
    }),
  );

  const platformLocationFieldConnections =
    platformLocationField?.community_member_profile_field?.location_connections;

  // If there are no connections, we should show the update your location notice
  const shouldShowUpdateYourLocationNotice =
    (platformLocationFieldConnections?.length ?? 0) === 0;

  // If there are connections AND first one is set by platform
  // we should show the "check" your location notice
  const shouldShowReviewYourLocationNotice =
    (platformLocationFieldConnections?.length ?? 0) > 0 &&
    (platformLocationFieldConnections?.[0]?.set_by_platform ?? false);

  const platformLocationText: string | null =
    platformLocationField?.community_member_profile_field.text;

  return {
    shouldShowUpdateYourLocationNotice,
    shouldShowReviewYourLocationNotice,
    platformLocationText,
  };
};

export const isPlatformLocationField = ({
  field_type,
  platform_field,
}: {
  field_type: FieldTypes;
  platform_field: boolean;
}) => field_type === FIELD_TYPES.LOCATION && platform_field;
